module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Extra income","amount":"Amount","loan":"Loan contract","description":"Description"},"et":{"title":"Extra income","amount":"Amount","loan":"Loan contract","description":"Description"},"ru":{"title":"Extra income","amount":"Amount","loan":"Loan contract","description":"Description"}}')
  delete Component.options._Ctor
}
